// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__omoIK","navbarMain":"Nav_navbarMain__aJ8P7","link":"Nav_link__l4-TI","linkIcon":"Nav_linkIcon__qiAIr","chevron":"Nav_chevron__HU9ie"};